import { FC } from "react";
import { Treemap, ResponsiveContainer, Tooltip } from "recharts";
import { IAiChart, ITreeMapChartConfig } from "./chartConfig";

const AiTreemapChart: FC<IAiChart> = ({ config, chartData }) => {
  const {
    data: { level1, level2, values },
  } = config as ITreeMapChartConfig;

  const transformedData = chartData.reduce((acc: any[], item) => {
    const category = item[level1.field];
    const subCategory = level2 ? item[level2.field] : null;
    const value = item[values.field];

    let categoryNode = acc.find((c) => c.name === category);
    if (!categoryNode) {
      categoryNode = { name: category, children: [] };
      acc.push(categoryNode);
    }

    if (subCategory) {
      categoryNode.children.push({ name: subCategory, size: value });
    } else {
      categoryNode.children.push({ name: category, size: value });
    }

    return acc;
  }, []);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <Treemap data={transformedData} dataKey="size" stroke="#fff">
        <Tooltip />
      </Treemap>
    </ResponsiveContainer>
  );
};

export default AiTreemapChart;
